import React, { useState, useEffect } from 'react'
import Icon from '@mdi/react';
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js';
import LogoImage from "../../assets/img/logo.svg";
import router from '../../router'
import i18n from '../../locales/i18n'
import Toast from "../../plugins/useToast";
import { useRecoilState } from "recoil";
import { audioPlayState } from '../../plugins/recoil';
import axios from '../../plugins/axios'
import { useTranslation } from 'react-i18next';

import {ReactComponent as IconCheckGray} from '../../assets/icons/ic-check-gray.svg';
import {ReactComponent as IconCheckBlue} from '../../assets/icons/ic-check-blue.svg';

const ChangePwd = () => {
    const { t } = useTranslation()
    const [isSecure, setIsSecure] = useState({
        passNow : true,
        pass : true,
        pass2 : true
    })    
    const [passNow, setPassNow] = useState('')
    const [pass, setPass] = useState('')
    const [pass2, setPass2] = useState('')
    const [, setPlayAudio] = useRecoilState(audioPlayState);
    const [passValid, setPassValid] = useState({
        lowerCase: false,
        number: false,
        specialChar: false,
        length: false,
        match: false
    });
    const isAllValid = Object.values(passValid).every(Boolean);

    const handleChangePassword = async () => {
        if (!pass || !pass2) return
        try {
            const res = await axios.put(`/user/me/password`, { newPassword: pass2, oldPassword: passNow })
            if (res.code != '200') throw res

            Toast({ isSuccess: true, msg: t(`login.changePasswordSuccess`) });
            router.navigate('/admin/main')
        } catch (err) {
            if(err.code == '2004'){
                Toast({ isSuccess: false, msg: t(`login.changePasswordMisMatch`) });
            }else {
                Toast({ isSuccess: false, msg: t(`login.changePasswordFail`) });
            }            
            console.error(err);
        }
    }

    const handleEnter = (e) => {
        if (e.keyCode === 13) {
            handleChangePassword()
        }
    }

    useEffect(() => {
        const hasServerError = localStorage.getItem("serverError");
        if (hasServerError == "SERVER") {
            Toast({ isSuccess: false, msg: t(`login.serverError`) });
            localStorage.removeItem('serverError')
        } else if (hasServerError == 'SESSION') {
            Toast({ isSuccess: false, msg: t(`login.sessionExpired`) });
            localStorage.removeItem('serverError')
        } else if (hasServerError) {
            Toast({ isSuccess: false, msg: t(`login.unknownError`) });
            localStorage.removeItem('serverError')
        }
    }, [])


    //비밀번호 유효성 검사
    useEffect(() => {
        setPassValid({
            passNow : passNow != '',
            lowerCase: /[a-z]/.test(pass),
            number: /[0-9]/.test(pass),
            specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(pass),
            length: pass.length >= 8 && pass.length <= 16,
            match: pass !== '' && pass === pass2
        });
    }, [pass, pass2,passNow]);

    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-[9999]">
            <div
                className="fixed inset-0 bg-[#29292E] flex items-center justify-center z-50"
                style={{                    
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className="absolute w-[540px]">                
                    <div className="text-center mb-[40px]">
                        <img src={LogoImage} alt="Logo" className="mx-auto mb-4 h-12" />
                        <h2 className="text-center text-[#C3C7D5] text-[36px] font-medium leading-[44px] font-['Pretendard']">ADMIN</h2>
                    </div>

                    <div className='flex w-full p-5 flex-col justify-center items-center rounded-lg bg-[#323238] shadow-[inset_0px_1px_0px_0px_rgba(0,0,0,0.4)]'>
                        <h2 className="mb-[8px] text-center text-[#E1E4E5] text-[24px] font-medium leading-[120%] font-['Pretendard']">Reset password</h2>
                        <p className="text-center text-[#8B8E94] text-[16px] font-normal font-['Pretendard'] leading-[120%] mb-2">For security reasons, you will be required to change your password<br/>upon first logging in.​</p>

                        <div className='relative w-full mt-[20px]'>
                            <input type={isSecure.passNow ? "password" : "text"} value={passNow} onChange={(e) => setPassNow(e.target.value)} onKeyDown={handleEnter} placeholder={t(`login.currentPassword`)} className="w-full p-2 border border-[#4B4D52] rounded-lg bg-[#0D0D0F] text-[#E1E4E5] placeholder-[#FFFFFF4D]" autoComplete="one-time-code"/>
                            <button type="button" onClick={() => setIsSecure({...isSecure, passNow: !isSecure.passNow})} className="absolute right-2 top-2">
                                <Icon path={isSecure.passNow ? mdiEyeOffOutline : mdiEyeOutline} size={1} color="#FFFFFF4D" />
                            </button>
                        </div>
                        <div className='relative w-full mt-[20px]'>
                            <input type={isSecure.pass ? "password" : "text"} value={pass} onChange={(e) => setPass(e.target.value)} onKeyDown={handleEnter} placeholder={t(`login.newPassword`)} className="w-full p-2 border border-[#4B4D52] rounded-lg bg-[#0D0D0F] text-[#E1E4E5] placeholder-[#FFFFFF4D]" autoComplete="one-time-code"/>
                            <button type="button" onClick={() => setIsSecure({...isSecure, pass: !isSecure.pass})} className="absolute right-2 top-2">
                                <Icon path={isSecure.pass ? mdiEyeOffOutline : mdiEyeOutline} size={1} color="#FFFFFF4D" />
                            </button>
                        </div>
                        <div className='flex w-full mt-2'>
                            <div className='flex items-center gap-2 mr-2'>
                                {passValid.lowerCase ? <IconCheckBlue /> : <IconCheckGray />}
                                <span className={`font-['Pretendard'] text-[16px] font-normal leading-[18px] text-[#ABAEB2]`}>One lowercase letter​</span> 
                            </div>
                            <div className='flex items-center gap-2 mr-2'>
                                {passValid.number ? <IconCheckBlue /> : <IconCheckGray />}
                                <span className={`font-['Pretendard'] text-[16px] font-normal leading-[18px] text-[#ABAEB2]`}>One number​</span> 
                            </div>
                            <div className='flex items-center gap-2'>
                                {passValid.passNow ? <IconCheckBlue /> : <IconCheckGray />}
                                <span className={`font-['Pretendard'] text-[16px] font-normal leading-[18px] text-[#ABAEB2]`}>Current Password</span> 
                            </div>                                                        
                        </div>
                        <div className='flex w-full my-2'>
                            <div className='flex items-center gap-2 mr-2'>
                                {passValid.specialChar ? <IconCheckBlue /> : <IconCheckGray />}
                                <span className={`font-['Pretendard'] text-[16px] font-normal leading-[18px] text-[#ABAEB2]`}>One special character​</span> 
                            </div>
                            <div className='flex items-center gap-2'>
                                {passValid.length ? <IconCheckBlue /> : <IconCheckGray />}
                                <span className={`font-['Pretendard'] text-[16px] font-normal leading-[18px] text-[#ABAEB2]`}>8-16 characters​</span> 
                            </div>
                        </div>
                        <div className='relative w-full mt-[20px]'>
                            <input type={isSecure.pass2 ? "password" : "text"} value={pass2} onChange={(e) => setPass2(e.target.value)} onKeyDown={handleEnter} placeholder={t(`login.confirmPassword`)} className="w-full p-2 border border-[#4B4D52] rounded-lg bg-[#0D0D0F] text-[#E1E4E5] placeholder-[#FFFFFF4D]" />
                            <button type="button" onClick={() => setIsSecure({...isSecure, pass2: !isSecure.pass2})} className="absolute right-2 top-2">
                                <Icon path={isSecure.pass2 ? mdiEyeOffOutline : mdiEyeOutline} size={1} color="#FFFFFF4D" />
                            </button>
                        </div>                        
                        <div className='flex w-full my-2'>
                            <div className='flex items-center gap-2'>
                                {passValid.match ? <IconCheckBlue /> : <IconCheckGray />}
                                <span className={`font-['Pretendard'] text-[16px] font-normal leading-[18px] text-[#ABAEB2]`}>Passwords must match</span> 
                            </div>   
                        </div>
                        <div className='w-full mt-[20px]'>                            
                            <button
                                disabled={isAllValid ? false : true}
                                onClick={handleChangePassword}
                                className={`w-full h-[40px] ${isAllValid ? 'bg-gradient-to-b from-[#3182F7] to-[#1562D1]' : 'border-[#0D0D0F] bg-[#404C5D]'}  text-white font-light text-[20px] rounded-[4px] transition`}
                            >
                                { t('admin.ok') }
                            </button>
                        </div>                        
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default ChangePwd